import { wixAxios } from '../../utils/wix-axios';

export const getHasUserInstalledOneapp = async (userId: string): Promise<boolean> => {
  return wixAxios
    .get(`/_api/wix-bi-profile-webapp/v2/user/${userId}?fields=one_app`)
    .then(response => {
      const { one_app } = response.data.fields;
      return Boolean(one_app);
    });
};
